import { useQuery } from 'react-query';

import { useApi } from '../../context/ApiContext';

export const useGetConsumption = (id) => {
  const client = useApi();

  return useQuery(['get-consumption', id], () => client.get(`/objectives/consumption/${id}`).then((res) => res.data));
};
